import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

const PRESSTO_PURPLE = '#5C4FB8';

export default function TemplatesAccessGate() {
  return (
    <Box
      sx={{
        minHeight: '70vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 3,
        py: 8,
      }}
    >
      <Box
        sx={{
          maxWidth: 520,
          textAlign: 'center',
          backgroundColor: '#FFFFFF',
          border: '2px solid #1e1e1e',
          borderRadius: '12px',
          boxShadow: '4px 4px 0px #1e1e1e',
          px: { xs: 4, md: 6 },
          py: { xs: 5, md: 7 },
        }}
      >
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            backgroundColor: '#FAF7F0',
            border: '2px solid #1e1e1e',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 3,
          }}
        >
          <LockOutlinedIcon sx={{ fontSize: 28, color: '#1e1e1e' }} />
        </Box>

        <Typography
          component="h2"
          sx={{
            fontFamily: 'Georgia, "Times New Roman", serif',
            fontWeight: 700,
            fontSize: { xs: '1.5rem', md: '1.85rem' },
            color: '#1e1e1e',
            mb: 1.5,
            lineHeight: 1.2,
          }}
        >
          Templates aren&apos;t enabled for your account yet
        </Typography>

        <Typography
          sx={{
            fontFamily: 'Lato, Inter, sans-serif',
            fontSize: '1rem',
            color: '#555',
            lineHeight: 1.55,
            mb: 4,
          }}
        >
          The Templates gallery hosts curriculum-aligned lessons (Really Great
          Reading and more on the way). Access is granted per school.
        </Typography>

        <Box
          component="a"
          href="mailto:hello@joinpressto.com?subject=Templates%20access"
          sx={{
            display: 'inline-block',
            backgroundColor: PRESSTO_PURPLE,
            color: '#FFFFFF',
            textDecoration: 'none',
            border: '2px solid #1e1e1e',
            borderRadius: '8px',
            boxShadow: '3px 3px 0px #1e1e1e',
            fontFamily: 'Montserrat, sans-serif',
            fontWeight: 700,
            fontSize: '0.95rem',
            px: 3,
            py: 1.5,
            transition: 'all 100ms ease-in-out',
            '&:hover': {
              transform: 'translate(-1px, -1px)',
              boxShadow: '4px 4px 0px #1e1e1e',
            },
          }}
        >
          Contact Pressto for access
        </Box>
      </Box>
    </Box>
  );
}
